import { fetchEndpoint } from '../server/network'

// 首页推荐商品列表
export const homeProductList = () => fetchEndpoint('/v2/ecapi.home.product.list')

//首页bannaer
export const homeBanner = () => fetchEndpoint('/v2/ecapi.banner.list')

//推荐商品
export const geStochastic = params => fetchEndpoint('/v2/ecapi.stochastic.list', 'post', params)

// 获取商品库存
export const getProductStock = (params) => fetchEndpoint('/v2/ecapi.product.getproductstock', 'POST', params)

// 商品列表
export const productList = (data) => fetchEndpoint('/v2/ecapi.product.list', 'POST', data)

// 商品详情
export const productGet = (params) => fetchEndpoint('/v2/ecapi.product.get', 'POST', { product: params })

// 商品问答
export const answerGet = product => fetchEndpoint('/v2/ecapi.answer.get', 'POST', { product: product })

//添加问题
export const issue = data => fetchEndpoint('/v2/ecapi.answer.issue', 'POST', data)

//文献
export const zhiLiaoWo = data => fetchEndpoint('/v2/ecapi.zhiliaowo.get', 'POST', data)

//产品分类
export const categoryList = (data) => fetchEndpoint('/v2/ecapi.category.list', 'POST', data)

//活动列表
export const activityProduct = data => fetchEndpoint('/v2/ecapi.activity.product', 'POST', data)

//活动分类
export const special = (params) => fetchEndpoint('/v2/ecapi.special.get', 'POST', params)

//活动分类activityCategory
export const activityTypes = () => fetchEndpoint('/v2/ecapi.activity.types', 'POST')

//套餐价格
export const mealPrice = (params) => fetchEndpoint('/v2/ecapi.meal.price', 'POST', params)

//套餐加入购物车
export const mealAddCart = (params) => fetchEndpoint('/v2/ecapi.meal.cart', 'POST', params)

//重选套餐
export const reelectPackage = (params) => fetchEndpoint('/v2/ecapi.reselect.package', 'POST', params)





//优惠换购
export const exchange = data => fetchEndpoint('/v2/ecapi.exchange.get', 'POST', data)

//收藏
export const collect = data => fetchEndpoint('/v2/ecapi.collect.get', 'POST', data)

// 已收藏的商品列表
export const productLikedList = (params) => fetchEndpoint('/v2/ecapi.product.liked.list', 'POST', params)

// 判断商品是否有效
export const productValidate = product =>
	fetchEndpoint('/v2/ecapi.product.validate', 'POST', {
		product: product // 有效商品
	})

// 立即购买
export const productPurchase = (params) => fetchEndpoint('/v2/ecapi.product.purchase', 'POST', params)


// WEBPACK FOOTER //
// ./src/api/product.js